"use client"

import Link from "next/link"
import { toast } from "sonner"
import { logout } from "@/app/actions/auth"
import { useTransition } from "react"
import { ThemeModeToggle } from "@/components/shared/ThemeModeToggle"
import { Button } from "@/components/ui/button"

type UserMenuProps = {
  onItemClick?: () => void
}

export function UserMenu({ onItemClick }: UserMenuProps) {
  const [isPending, startTransition] = useTransition()

  const handleSignOut = () => {
    onItemClick?.()
    toast.success("Logout effettuato con successo")
    startTransition(async () => {
      await logout()
    })
  }

  const handleProfileClick = () => {
    onItemClick?.()
  }

  return (
    <>
      <Link
        href="/account"
        className="flex items-center gap-3 px-4 py-3 text-muted-foreground hover:bg-accent/60 transition"
        onClick={handleProfileClick}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
        <span>Il Mio Profilo</span>
      </Link>
      <Link
        href="/account/security"
        className="flex items-center gap-3 px-4 py-3 text-muted-foreground hover:bg-accent/60 transition"
        onClick={handleProfileClick}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
        <span>Sicurezza</span>
      </Link>
      <Link
        href="/account/preferences"
        className="flex items-center gap-3 px-4 py-3 text-muted-foreground hover:bg-accent/60 transition"
        onClick={handleProfileClick}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <span>Preferenze</span>
      </Link>
      <div className="border-t border-border"></div>
      <div className="px-4 py-3">
        <p className="text-xs font-medium text-muted-foreground mb-2">Tema</p>
        <ThemeModeToggle />
      </div>
      <div className="border-t border-border"></div>
      <Button
        onClick={handleSignOut}
        disabled={isPending}
        variant="ghost"
        className="w-full justify-start rounded-none h-auto px-4 py-3 text-red-600 hover:bg-red-50"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        <span>{isPending ? "Logout..." : "Logout"}</span>
      </Button>
    </>
  )
}
